/// <reference types="vite-plugin-svgr/client" />
import { X as XIcon } from 'react-feather';
import ErrorIconImage from '~/assets/images/error-icon.svg?react';
import { Alert, Box, Button, IconButton, Modal } from '@mui/material';
import usePaymentErrorModalStore from './hooks/usePaymentErrorModalStore';

export default function PaymentErrorModal({
  errorOpen,
  handleModalClose,
  handleModalLocalClose,
}: {
  errorOpen: boolean;
  handleModalClose: Function;
  handleModalLocalClose: Function;
}) {
  const msg = usePaymentErrorModalStore((state: any) => state.msg);
  const setMsg = usePaymentErrorModalStore((state: any) => state.setMsg);

  const handleClose = () => {
    setMsg('');
    handleModalClose();
  };
  const handleLocalClose = () => {
    setMsg('');
    handleModalLocalClose();
  };

  return (
    <Modal
      open={errorOpen}
      onClose={() => handleClose()}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <Box
        sx={{
          borderRadius: '10px',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 600,
          bgcolor: 'rgb(246, 247, 251)',
        }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'right', p: 3 }}>
          <IconButton onClick={() => handleLocalClose()}>
            <XIcon size={16} />
          </IconButton>
        </Box>

        <Box sx={{ px: 8, display: 'grid', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ margin: '0 auto' }}>
            <ErrorIconImage />
          </div>
          <h2 style={{ textAlign: 'center', margin: 0 }}>Payment Failed</h2>
          <p style={{ textAlign: 'center' }}>
            The payment could not be processed or the payment method could not be verified. Please try again
          </p>
          {msg ? (
            <Alert
              variant="outlined"
              severity="error"
              sx={{
                textAlign: 'center',
                justifyContent: 'center',
                margin: '0',
                backgroundColor: 'error.light',
                borderWidth: 1,
                borderColor: 'error.dark',
                borderStyle: 'solid',
                borderRadius: 2,
                alignItems: 'center',
                '& .MuiAlert-action': {
                  pt: 0,
                },
              }}>
              {msg}
            </Alert>
          ) : (
            <></>
          )}
        </Box>

        <Box sx={{ pt: 3, pb: 6, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Button
            variant="outlined"
            color="secondary"
            size="large"
            onClick={() => handleLocalClose()}
            sx={{ width: '240px' }}>
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
